import { useEffect } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { professionalHasB2CPermission } from '@/utils/professionalPermissionTags';

type ProfessionalLayoutContext = {
	data: Professionals.Professional | undefined;
	isLoading: boolean;
};

export const useRequireB2CPermission = () => {
	const navigate = useNavigate();
	const context = useOutletContext<ProfessionalLayoutContext | null>();
	const professional = context?.data;
	const isLoading = context?.isLoading ?? false;
	const canManageAvailability = professionalHasB2CPermission(professional);

	useEffect(() => {
		if (isLoading) return;
		if (!canManageAvailability) {
			navigate('/profissional/home', { replace: true });
		}
	}, [isLoading, canManageAvailability, navigate]);

	return { professional, isLoading, canManageAvailability };
};
